import { API_BASE_URL } from '../config';
import { adminFetch } from '../utils/adminFetch';

export type InvitationDeliveryMode = 'EMAIL' | 'MANUAL';

export interface SendInvitationRecipient {
  email: string;
  name: string;
}

export interface SendInvitationRequest {
  subject: string;
  body: string;
  deadline: string;
  recipients: SendInvitationRecipient[];
  docCodes: string[];
  formCodes: string[];
  formEmployerContext: Record<string, Record<string, string>>;
  deliveryMode?: InvitationDeliveryMode;
}

export interface RenderedInvitationMessage {
  email: string;
  name: string;
  subject: string;
  body: string;
}

export interface SendInvitationResponse {
  sent: number;
  failed: number;
  errors: string[];
  deliveryMode?: InvitationDeliveryMode;
  renderedMessages?: RenderedInvitationMessage[];
}

export async function sendInvitations(
  request: SendInvitationRequest
): Promise<SendInvitationResponse> {
  const res = await adminFetch(`${API_BASE_URL}/api/invitations/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...request,
      deliveryMode: request.deliveryMode ?? 'EMAIL',
    }),
  });

  const data = (await res.json()) as SendInvitationResponse & { errors?: string[] };

  if (!res.ok) {
    const errText =
      data.errors?.[0] ??
      (typeof (data as { message?: string }).message === 'string'
        ? (data as { message: string }).message
        : '送信に失敗しました。');
    throw new Error(errText);
  }

  return {
    sent: data.sent ?? 0,
    failed: data.failed ?? 0,
    errors: data.errors ?? [],
    deliveryMode: data.deliveryMode,
    renderedMessages: data.renderedMessages ?? [],
  };
}
